import { useState } from 'react'
import styled from 'styled-components'

import { CircularLoader } from '@blade/ui-kit'
import { RectangleNetworkBackground } from '@root/shared/ui'

import * as KnownSocialPlatformResource from '../model/known-social-platform-resource'

import { SocialBlueskyEmbed } from './social-bluesky-embed'
import { SocialFacebookEmbed } from './social-facebook-embed'
import { SocialGithubEmbed } from './social-github-embed'
import { SocialIframeEmbed } from './social-iframe-embed'
import { SocialImageEmbed } from './social-image-embed'
import { SocialPinterestEmbed } from './social-pinterest-embed'
import { SocialTiktokEmbed } from './social-tiktok-embed'
import { SocialWikiEmbed } from './social-wiki-embed'
import { SocialXEmbed } from './social-x-embed'

export const SocialEmbed = ({
  resource,
}: {
  resource: KnownSocialPlatformResource.KnownSocialPlatformResource
}) => {
  const [loading, setLoading] = useState(true)
  return (
    <Root>
      {loading ? (
        <Loader>
          <CircularLoader size={24} />
        </Loader>
      ) : undefined}
      {KnownSocialPlatformResource.matchEmbedType(resource, {
        onIframe: (iframe) => (
          <SocialIframeEmbed
            resource={iframe}
            onLoad={() => setLoading(false)}
          />
        ),
        onWiki: (wiki) => (
          <SocialWikiEmbed
            articleLanguage={wiki.articleLanguage}
            articleTitle={wiki.articleTitle}
            url={wiki.url}
          />
        ),
        onX: (x) => (
          <SocialXEmbed resource={x} onResize={() => setLoading(false)} />
        ),
        onGithub: (github) => <SocialGithubEmbed username={github.username} />,
        onImage: (image) => (
          <SocialImageEmbed
            linkUrl={image.url}
            imageUrl={KnownSocialPlatformResource.toRepoOpenGraphImageUrl(
              image,
            )}
            unsafeUrlProvider={image._tag}
            alt={`${image.username}/${image.repo}`}
            onLoad={() => setLoading(false)}
          />
        ),
        onBluesky: (bluesky) => (
          <SocialBlueskyEmbed
            onLoad={() => setLoading(false)}
            resource={bluesky}
          />
        ),
        onFacebook: (facebook) => (
          <SocialFacebookEmbed
            onLoad={() => setLoading(false)}
            resource={facebook}
          />
        ),
        onPinterest: (pinterest) => (
          <SocialPinterestEmbed
            resource={pinterest}
            onLoad={() => setLoading(false)}
          />
        ),
        onTiktok: (tiktok) => (
          <SocialTiktokEmbed
            onLoad={() => setLoading(false)}
            resource={tiktok}
          />
        ),
      })}
    </Root>
  )
}

const Root = styled.div`
  ${RectangleNetworkBackground}

  position: relative;
  width: 100%;
  max-height: var(--viewport-height);
  overflow: auto;
`
const Loader = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`
